import { ContainerModule } from 'inversify';
import { DomainConfig } from '@/Framework/config/DI/DomainConfig';
import { DataroomDomainConfig } from './DataroomDomainConfig';
import { TYPES } from '@/Framework/config/DI/types';

export const domainModule = new ContainerModule((bind) => {
  bind<DomainConfig>(TYPES.DomainConfig).to(DataroomDomainConfig).inSingletonScope();
});
